module.exports = __webpack_public_path__ + "static/media/Darwin_Editor.df078777.svg";